<template>
  <div class="page-size-select d-flex align-items-center">
    <span class="page-size-select__label mr-2">{{ $t('table.general.page_size') }}</span>
    <b-form-select
      class="page-size-select__control"
      :value="value"
      :options="options"
      @change="$emit('change', Number($event))"
    />
  </div>
</template>

<script>

  export default {
    name: 'PageSizeSelect',

    props: {
      value: {
        type: Number,
        required: true
      },
      options: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style>
  .page-size-select__label {
    white-space: nowrap;
  }
  .page-size-select__control {
    width: auto;
  }
</style>
